define(function (require) {
    "use strict";
    var Backbone = require('backbone');
    var RadioButtonModel =  require("ui/radio-button-list/js/models/RadioButtonModel");

    var RadioButtonCollection = Backbone.Collection.extend({
        model: RadioButtonModel
    });

    return RadioButtonCollection;
});